import { css, cx } from 'core/emotion';
import { isMobile, isTablet } from 'react-device-detect';
import Popover from 'baseUI/Popover';
import Message from 'baseUI/Popover/Message';
import { useState, useMemo } from 'react';
import { ReactComponent as InfoBlackIcon } from '../../../assets/icon/info-icon-black.svg';
import { Boundary } from '@popperjs/core';

const maxStyle = css`
  text-align: left;
  max-width: 320px;
`;

const overflowCheckOffset = {
  top: 10,
  left: 0,
  right: 0,
  bottom: 0,
};

const PopoverInfo = ({
  description,
  configTheme,
  boundary,
  flip,
}: {
  description: string;
  configTheme?: string;
  boundary?: Boundary;
  flip?: boolean;
}) => {
  const [isShow, setIsShow] = useState(false);

  const getHandleHelpInfoEvent = () => {
    if (!isMobile && !isTablet) {
      return {
        onMouseEnter: () => {
          setIsShow(true);
        },
        onMouseLeave: () => {
          setIsShow(false);
        },
      };
    } else {
      return {
        onClick: () => {
          setIsShow(true);
        },
        onMouseLeave: () => {
          setIsShow(false);
        },
      };
    }
  };

  const iconStyled = useMemo(() => {
    return configTheme;
  }, [configTheme]);

  return (
    <Popover
      flip={flip}
      isShow={isShow}
      offset={[0, 8]}
      direction="top-start"
      boundary={boundary}
      overflowCheckOffset={overflowCheckOffset}
      message={
        <Message className={maxStyle} variant="info">
          {description}
        </Message>
      }
      className={`pointer-events-none ${isShow ? 'visible' : 'invisible'}`}
      render={({ referenceElement }) => {
        return (
          <span
            ref={referenceElement}
            className={cx('text-gray-260 flex-shrink-0', iconStyled)}
            {...getHandleHelpInfoEvent()}
          >
            <InfoBlackIcon className={cx('h-4 w-4 rotate-180 transform')} />
          </span>
        );
      }}
    />
  );
};

export default PopoverInfo;
